import axios from 'axios';
import logger from '../utils/logger';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000',
  headers: {
    'Content-Type': 'application/json'
  }
});

// Request interceptor
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    // Log API request
    logger.debug('API Request', {
      method: config.method,
      url: config.url,
      params: config.params
    });
    
    return config;
  },
  (error) => {
    logger.error('API Request Error', error);
    return Promise.reject(error);
  }
);

// Response interceptor
api.interceptors.response.use(
  (response) => {
    // Log successful response
    logger.debug('API Response', {
      method: response.config.method,
      url: response.config.url,
      status: response.status
    });
    
    return response;
  },
  (error) => {
    // Log error response
    logger.logApiError(
      error.config?.url,
      error,
      error.response
    );
    
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('userRole');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
